const getBrowserLanguage = () => {
    var defaultLanguage = navigator.language;
    if (!defaultLanguage) {
        defaultLanguage = navigator.userLanguage;
    }
    if (!defaultLanguage) {
        defaultLanguage = 'en';
    }
    return defaultLanguage;
}
const INITIAL_STATE = {
    currentLanguage: getBrowserLanguage(),
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case "SET_LANGUAGE":
            return {currentLanguage: action.payload};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/i18n.js